module.exports = __webpack_public_path__ + "img/stone-furnace-fire.ff67a538.png";